import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var arrow_up_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M12 3.9 6.5 9.5l1 1 3.8-3.7V20h1.5V6.8l3.7 3.7 1-1z" }) });
export {
  arrow_up_default as default
};
//# sourceMappingURL=arrow-up.js.map
